export const animation = { spine: 'animations/spine/lines/skeleton.json' }
export const typeLine = 'polyline'//spine or polyline
export const lineSetting = {
  texture: 'line_base_add',
  blendMode: PIXI.BLEND_MODES.NORMAL,
  alpha: 1,
  drawType: 'regular',
  animation: {
    alpha: 0.6,
    in: 0.3,
    end: 0.5,
    delay: 0.3,
  },
}
